<style scoped>
#content {
  padding-top: 64px;
}

.fixed-filter {
  position: fixed;
  z-index: 1;
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}

.custom-btn:hover {
  color: #ffffff;
}
</style>

<template lang="pug">
div
  app-delivery-bar(:fixed='true', :top='"64px"')
  v-container#content
    .vspace.medium
    v-row
      //- .col.l2.fixed-filter.hide-on-med-and-down
      v-col.hide-on-med-and-down(cols='12', lg='3')
        app-drink-filter(
          :categories='categories',
          :activeCategory='activeCategory',
          :searchKey='searchKey',
          @onSearchKeyword='onSearch',
          @onFilterCategory='filterCategory'
        )
      v-col#filter-container.hide-on-large-only(cols='12', sm='12')
        .vspace.small
        a.btn.btn-flat.custom-btn(@click='showFilter')
          i.material-icons.left filter_list
          | filters
      //- .col.s12.l9.offset-l3
      v-col(cols='12', lg='9')
        //- div(v-if='user.length')
        //-   pre {{user.length}}
        //- div(v-else)
        //-   p no
        .row
          p.subtitle.light(v-if='$route.query.name') Showing search results for "{{ $route.query.name }}"
        //- pre {{drinks}}
        paginate.product-list(
          name='drinks',
          :list='drinks',
          :per='12',
          ref='paginator'
        )
          app-product-card(
            v-for='(drink, index) in paginated("drinks")',
            :key='index',
            :product='drink',
            :userlogs='userlog',
            :index='index',
            :path='drink.shop.code + "/" + drink.productCode + "?v=" + drink.variant.variantCode'
          )
        p.subtitle.large.center-align(v-if='!drinks.length') No items found
        .paginate-panel.mb-5(v-if='drinks.length > 12')
          paginate-links(for='drinks', :limit='4', :show-step-links='true')
</template>
<script>
import AppProductCard from '@/components/app-product-card'
import AppDrinkDetails from '@/components/app-drink-details'
import AppDeliveryBar from '@/components/app-delivery-bar'
import AppDrinkFilter from '@/components/app-drink-filter'
import axios from 'axios'
require('vue-modal/dist/vue-modal-store')

export default {
  name: 'drinks',
  meta: {
    title: 'Drinks',
  },
  props: ['userlog'],
  data() {
    return {
      filterModal: AppDrinkFilter,
      drinkModal: AppDrinkDetails,
      drinks: [],
      activeCategory: 'all',
      searchKey: null,
      categories: [],
      pagination: {
        startPage: 0,
        lastPage: 0,
      },
      paginate: ['drinks'],
    }
  },
  components: {
    AppProductCard,
    AppDrinkDetails,
    AppDeliveryBar,
    AppDrinkFilter,
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    hasuser() {
      return this.$store.state.user
    },
    filterDrinksbyTag() {
      let filter
      if (this.hasuser !== null) {
        let userType = this.user.type
        if (userType === 'reseller') {
          filter = { conventional: true }
          return this.drinks.filter((item) => filter[item.tags])
        } else if (userType === 'customer') {
          filter = { 'The Scotch Malt Whisky Society': true }
          return this.drinks.filter((item) => filter[item.tags])
        } else {
          return this.drinks
        }
      } else {
        return this.drinks
      }
      // return this.drinks
    },
    emptyDrinks() {
      return this.drinks.length == 0
    },
  },
  created() {
    this.getDrinks()
    this.updateModal()
    this.searchKey = this.$route.query.name
    this.setCategories()
    this.activeCategory = this.$route.query.category
  },
  watch: {
    '$store.state.config.categories'() {
      this.setCategories()
    },
    '$route.params'() {
      this.updateModal()
    },
    '$route.query'() {
      this.getDrinks()
    },
    '$store.state.cart.location'() {
      this.getDrinks()
    },
    emptyDrinks: function (newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        setTimeout(() => {
          if (this.$refs.paginator) {
            this.$refs.paginator.goToPage(1)
          }
        }, 100)
      }
    },
  },
  methods: {
    showFilter() {
      const modalParams = {
        content: AppDrinkFilter,
        style: { fullscreen: true, padding: 'medium' },
        bind: {
          onFilterCategory: this.filterCategory,
          onSearchKeyword: this.onSearch,
          categories: this.categories,
          activeCategory: this.activeCategory,
          searchKey: this.searchKey,
        },
      }
      this.$store.dispatch('modal/open', modalParams)
    },
    setCategories() {
      this.categories = ['all']
      if (!this.$store.state.config.categories) {
        return
      }

      this.$store.state.config.categories.forEach((category) => {
        this.categories.push(category.name)
      })
    },
    getDrinks() {
      axios
        .get(`${this.$config.API_URL}/products/`, {
          params: {
            ...this.$route.query,
            location: this.$store.state.cart.location,
          },
        })
        .then((result) => {
          this.drinks = result.data
        })
    },
    close() {
      this.$router.back()
    },
    onAdded() {
      this.$store.dispatch('modal/close')
    },
    updateModal() {
      if (this.$route.params.productCode && this.$route.params.shopCode) {
        const product = {
          shopCode: this.$route.params.shopCode,
          productCode: this.$route.params.productCode,
        }

        const modalParams = {
          parent: this.$store,
          content: AppDrinkDetails,
          bind: { viewProduct: product, onAddedHandler: this.onAdded },
          style: { padding: 'none' },
          onClose: this.close,
        }
        this.$store.dispatch('modal/open', modalParams)
      } else {
        this.$store.dispatch('modal/close')
      }
    },
    onSearch(searchKey) {
      this.searchKey = searchKey

      let query = {
        ...this.$route.query,
        name: searchKey,
      }

      if (!searchKey) {
        delete query['name']
      }

      this.$router.push({ path: this.$route.path, query: query })
    },
    filterCategory(category) {
      let query = {
        ...this.$route.query,
        category: category,
      }

      this.activeCategory = category

      if (!category || category === 'all') {
        delete query['category']
      }

      this.$router.push({ path: this.$route.path, query: query })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-drinks.vue